import { Component } from '@angular/core';

@Component({
	selector: 'app-ui-showcase',
	templateUrl: './ui-showcase.component.html'
})
export class UiShowcaseComponent {}
